import dynamic from "next/dynamic";
import { ChatbotEmbedConfigSchema, type ChatbotBlock } from "../types";
import { useChatbot } from "./ChatbotContext";
import ErrorEmbedIcon from "./ErrorEmbedIcon";

const CustomEmbedIcon = dynamic(() => import("./ChatbotTailwindEmbedIcon"), {
  ssr: false,
});

type Props = {
  block: ChatbotBlock;
  isHidden: boolean;
  onClickToggleHandler: () => void;
};

export function ChatbotEmbedIcon(props: Readonly<Props>) {
  const { status, initChatbotResponse, error } = useChatbot();

  if (status === "pending") {
    return null;
  }

  if (status === "rejected" || error) {
    return <ErrorEmbedIcon {...props} />;
  }

  if (initChatbotResponse?.isLocked) {
    return <ErrorEmbedIcon {...props} iconName="alertTriangle" />;
  }

  return (
    <CustomEmbedIcon
      {...props}
      embed={ChatbotEmbedConfigSchema.parse(props.block.config)}
    />
  );
}
